import StatusColumn from './StatusColumn';
import type { StatusColumnProps } from './types';

export default StatusColumn;
export type { StatusColumnProps };
